import getSafeRedirectPath from './getSafeRedirectPath';
import hasControlChars from './hasControlChars';

/**
 * Returns `value` only if it is a same-origin path or an absolute https URL
 * without embedded credentials; otherwise returns `null`. Rejects "javascript:",
 * "data:", http and every other scheme.
 * @param {string | null | undefined} value
 * @returns {string | null}
 */
export default function getSafeRedirectUrl(value) {
  if (typeof value !== 'string') return null;

  if (value.startsWith('/')) {
    return getSafeRedirectPath(value, null);
  }

  if (hasControlChars(value)) return null;

  try {
    const { protocol, username, password } = new URL(value);
    const isSafe = protocol === 'https:' && !username && !password;
    return isSafe ? value : null;
  } catch (_) {
    return null;
  }
}
